import { useEffect, useState } from "react";
// css
import "./confirmBooking.css";
//
import axios from "axios";
// other
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import CustomInput from "Utills/CustomInput/CustomInput";
import CalendarIcon from "assets/Images/icons/Calendar.svg";
import { Calendar } from "react-date-range";
import CustomModel from "Utills/Model/CustomModel";
import Moment from "moment";
import AllofferCard from "Utills/AllofferCard";
import Loader from "Components/others/Loader";
import { useNotifyContext } from "context/notifyContext";
import { Slide } from "react-reveal";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import NotLoggedIn from "Components/notLoggedIn";
//

// ============ api endpoint ================
let api_domain = process.env.REACT_APP_API_DOMAIN;
let api_booking = process.env.REACT_APP_API_OFFER_BOOK;
let api_all_offers = process.env.REACT_APP_ALL_INCLUSIVE_OFFERS;

//============================== THIS IS A CONFIRM BOOKING PAGE =============================================
const ConfirmBooking = (props) => {
  // notification
  const { set_notify, loader, set_loader } = useNotifyContext();
  let { id } = useParams();
  // user
  let user = props.current_user;
  //
  const [loaded, setLoaded] = useState(false);
  //
  const [loginModal, setLoginModal] = useState(false);
  //
  const [selectedOffer, setSelectedOffer] = useState({
    tittle: "",
    price: "",
    viewMoreLink: "",
    amenities: [],
    extras: [],
    general_pictures: [],
    residenceText: "",
    users: "",
    thumbnail: "",
    img1: "",
    img2: "",
    period: "",
  });
  // pickup modal state
  const [pickupDateModal, setPickupCalendar] = useState(false);
  // data modal state
  const [dateModal, setDateCal] = useState(false);
  // form data state
  const [formData, setFormData] = useState({
    pickup_date: null,
    date: null,
    description: "",
    guests: 1,
    location: "",
    pickUpName: "",
    checkInHour: "",
    phone: "",
    email: "",
    name: "",
    phone: "",
    surname: "",
  });
  // errors state
  const [errors, setErrors] = useState({
    pickup_date: {
      inValid: false,
      msg: "",
    },
    date: {
      inValid: false,
      msg: "",
    },
    description: {
      inValid: false,
      msg: "",
    },
    guests: {
      inValid: false,
      msg: "",
    },
    location: {
      inValid: false,
      msg: "",
    },
    pickUpName: {
      inValid: false,
      msg: "",
    },
    checkInHour: {
      inValid: false,
      msg: "",
    },
    phone: {
      inValid: false,
      msg: "",
    },
    surname: {
      inValid: false,
      msg: "",
    },
    name: {
      inValid: false,
      msg: "",
    },
    email: {
      inValid: false,
      msg: "",
    },
  });
  // ================= this will check id for booking ==================
  useEffect(() => {
    if (id && user?.isAuth) {
      setFormData({
        ...formData,
        ...user,
      });
      let url = api_all_offers + id?.toString();
      axios
        .get(url, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let data = response?.data;
          if (data?.status !== "error") {
            window.scrollTo(0, 0);
            setLoaded(true);
            setSelectedOffer(data?.offer);
          }
        })
        .catch((err) => {
          console.log("Error ====>", err.message);
        });
    }
  }, [id, user]);

  // Email validator
  const emailValidator = (email, showAlert) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    // if (showAlert) {
    //     set_notify({ msg: "You have entered an invalid email address!", type: 'info', open: true })
    // }
    return false;
  };
  // Submit offer to APi
  const submitOffer = async () => {
    let url = api_booking;
    let token = await localStorage.getItem("cyan_user");
    let userToken = JSON.parse(token) || "";
    // check all the required fields and submit offer request
    if (user?.isAuth) {
      if (
        // formData?.pickUpName?.trim()?.length > 0 &&
        // formData?.location?.trim()?.length > 0 &&
        // formData?.pickup_date && formData?.pickup_date?.toDateString()?.length > 0 &&
        // formData?.checkInHour?.toString().trim()?.length > 0 &&
        formData?.date &&
        formData?.date?.toDateString()?.length > 0 &&
        formData?.phone?.toString()?.length > 0 &&
        formData?.surname?.toString()?.length > 0 &&
        formData?.name?.toString()?.length > 0 &&
        formData?.email?.toString()?.length > 0 &&
        formData?.description?.toString()?.length > 0 &&
        // !errors.pickUpName.inValid &&
        // !errors.location.inValid &&
        // !errors.pickup_date.inValid &&
        !errors.date.inValid &&
        !errors.phone.inValid &&
        emailValidator(formData.email, "yes") &&
        !errors.surname.inValid &&
        !errors.name.inValid &&
        !errors.email.inValid &&
        !errors.description.inValid
        // !errors.checkInHour.inValid
      ) {
        if (loaded) {
          set_loader(true);
          let dataObj = {
            offer: id,
            start_date: Moment(formData?.date).format("YYYY-MM-DD"),
            // pickup_location: formData?.location,
            // pickup_date: Moment(formData?.pickup_date).format('YYYY-MM-DD'),
            // pickup_hour: Number(formData?.checkInHour),
            people_transfer: Number(formData?.guests),
            people: Number(selectedOffer?.num_of_people),
            notes: formData?.description,
          };
          axios({
            method: "POST",
            url: url,
            data: dataObj,
            headers: {
              Authorization: `Token ${userToken}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              let data = response?.data;
              if (data.status !== "error") {
                setFormData({
                  pickup_date: null,
                  date: null,
                  description: "",
                  guests: 1,
                  location: "",
                  pickUpName: "",
                  checkInHour: "",
                });
                // set_notify({ open: true, type: "success", msg: "Your booking request submitted successfully. Thanks for choosing CYAN." })
                set_loader(false);
                setTimeout(() => {
                  props?.history?.push("/bookingCompleted/" + id, id);
                }, 200);
              } else {
                set_loader(false);
                set_notify({
                  open: true,
                  msg: data?.["error-message"],
                  type: "error",
                });
                console.log("Error  ====>", data);
              }
            })
            .catch((err) => {
              console.log("Error ====>", err.message);
              set_notify({ open: true, type: "error", msg: err.message });
              set_loader(false);
            });
        } else {
          set_notify({ open: true, msg: "Offer Id Not Found.", type: "error" });
        }
      } else {
        // set_notify({ open: true, msg: "Please fill all the required fields properly.", type: "error" });
        let ob = {};
        let toCheck = [
          // 'pickup_date',
          "date",
          "phone",
          "description",
          "name",
          "email",
          // 'guests',
          // 'location',
          // 'pickUpName',
          // 'checkInHour',
        ];
        toCheck.map((d) => {
          if (!formData[d?.toString()]?.toString()?.trim()?.length > 0) {
            ob = {
              ...ob,
              [d?.toString()]: {
                inValid: true,
                msg:
                  d?.toString() === "email"
                    ? "Invalid email address"
                    : "required*",
              },
            };
          }
        });
        setErrors({ ...errors, ...ob });
      }
    } else {
      set_notify({
        open: true,
        msg: "Please create you account or logged in your account to book an  inclusive offer",
        type: "error",
      });
      setLoginModal(true);
    }
  };
  // handle input change
  const handleForm = (e) => {
    let { name, value } = e.target;
    switch (name) {
      case "description":
        if (value.length <= 500) {
          setFormData({
            ...formData,
            [name]: value,
          });
          setErrors({
            ...errors,
            [name]: {
              inValid: false,
              msg: "",
            },
          });
        }
        break;
      case "checkInHour":
        if (Number(value) <= 48) {
          setFormData({
            ...formData,
            [name]: value,
          });
          setErrors({
            ...errors,
            [name]: {
              inValid: false,
              msg: "",
            },
          });
        } else {
          setFormData({
            ...formData,
            [name]: value,
          });
          setErrors({
            ...errors,
            [name]: {
              inValid: true,
              msg: "Check In Hours should be between 0 to 48",
            },
          });
        }
        break;
      case "pickUpName":
      case "surname":
      case "name":
      case "phone":
      case "location":
        setFormData({
          ...formData,
          [name]: value,
        });
        if (value?.trim()?.length > 0) {
          setErrors({
            ...errors,
            [name]: {
              inValid: false,
              msg: "",
            },
          });
        } else {
          setErrors({
            ...errors,
            [name]: {
              inValid: true,
              msg: "required*",
            },
          });
        }
        break;
      case "email":
        if (emailValidator(value)) {
          setErrors({
            ...errors,
            [name]: {
              inValid: false,
              msg: "",
            },
          });
        } else {
          setErrors({
            ...errors,
            [name]: {
              inValid: true,
              msg: "Invalid email address*",
            },
          });
        }
        setFormData({
          ...formData,
          [name]: value,
        });
        break;
    }
  };

  // show this page if user is logged in and offer data is fetched from APi
  if (user?.isAuth && loaded) {
    return (
      <div className="confirmPage">
        <div className="cs_container">
          <div className="row py-4 overflow-hidden">
            <div className="col-12">
              <Slide left>
                <h3>Request Voyage</h3>
              </Slide>
            </div>
            <div className="col-md-7 mt-md-4 mt-2">
              <Slide bottom>
                <p className="text-pr ">
                  Fill the following form with your booking information. We
                  usually reply within 1 hour.
                </p>
              </Slide>
              <div className="px-md-2">
                {/* <h5 className="text-gr mt-md-3 mt-2 p-0">Transfer</h5> */}
                {/* <hr className="m-0" /> */}
                {/* <div className="row mt-2">
                                    <div className="col-12">
                                        <div className="main-input d-flex my-1 justify-content-between align-items-start">
                                            <div className="profile-labels add-list-all-labels text-left "><label htmlFor="" className="text-gr">Location</label></div>
                                            <div className="profile-inputs-wrapper">
                                                <CustomInput name="location" blueborder={"true"} placeholder="Enter"
                                                    onChange={handleForm} value={formData.location}
                                                />
                                                {errors?.location?.inValid && <span className="text-danger mt-0">{errors?.location?.msg}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="main-input d-flex my-1 justify-content-between align-items-start">
                                            <div className="profile-labels add-list-all-labels text-left "><label htmlFor="" className="text-gr">Pick-up name</label></div>
                                            <div className="profile-inputs-wrapper">
                                                <CustomInput name="pickUpName" blueborder={"true"} placeholder="Enter"
                                                    onChange={handleForm} value={formData.pickUpName}
                                                />
                                                {errors?.pickUpName?.inValid ? <span className="text-danger mt-0">{errors?.pickUpName?.msg}</span> : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="main-input d-flex my-1 justify-content-between align-items-start">
                                            <div className="profile-labels add-list-all-labels text-left ">
                                                <label htmlFor="" className="text-gr">Pick-up date</label></div>
                                            <div className="profile-inputs-wrapper">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="w-48 p-0">
                                                        <CustomInput
                                                            blueborder={"true"}
                                                            onClick={() => setPickupCalendar(prev => !prev)}
                                                            readOnly
                                                            start_icon={<img className="cursor-pointer" onClick={() => setPickupCalendar(prev => !prev)} src={CalendarIcon} alt="" />}
                                                            type="text"
                                                            name="pickup_date"
                                                            value={formData?.pickup_date ?
                                                                Moment(formData?.pickup_date?.toString()).format("MMM Do YYYY")
                                                                : ''
                                                            }
                                                            placeholder="mm/dd/yyyy"
                                                            className="text-center text-sec"
                                                        />
                                                        {errors?.pickup_date?.inValid && <span className="text-danger mt-0">{errors?.pickup_date?.msg}</span>}

                                                    </div>
                                                    <div className="w-48 p-0">
                                                        <CustomInput
                                                            start_icon={
                                                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                                    <path d="M14 0C21.742 0 28 6.272 28 14C28 21.742 21.742 28 14 28C6.272 28 0 21.742 0 14C0 6.272 6.272 0 14 0ZM13.51 6.902C12.936 6.902 12.46 7.364 12.46 7.952V15.022C12.46 15.386 12.656 15.722 12.978 15.918L18.466 19.194C18.634 19.292 18.816 19.348 19.012 19.348C19.362 19.348 19.712 19.166 19.908 18.83C20.202 18.34 20.048 17.696 19.544 17.388L14.56 14.42V7.952C14.56 7.364 14.084 6.902 13.51 6.902Z" fill="#3F8BBF" />
                                                                </svg>
                                                            }
                                                            name="checkInHour"
                                                            type="number"
                                                            blueborder={"true"}
                                                            className="text-sec"
                                                            placeholder="Hours 0 to : 48"
                                                            onChange={handleForm}
                                                            value={formData.checkInHour}
                                                        />
                                                        {errors?.checkInHour?.inValid && <span className="text-danger mt-0">{errors?.checkInHour?.msg}</span>}

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                <h5 className="text-gr mt-md-3 mt-2 p-0">
                  Reservation information
                </h5>
                <hr className="m-0" />
                <div className="row mt-2">
                  <div className="col-12">
                    <div className="col-12">
                      <div className="main-input d-flex my-2 justify-content-between align-items-center">
                        <div className="profile-labels add-list-all-labels text-left ">
                          <label htmlFor="" className="text-gr">
                            Name
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper">
                          <CustomInput
                            name="name"
                            placeholder="First name"
                            onChange={handleForm}
                            value={formData?.name}
                            wrapperClassName="mb-0"
                          />
                          {errors?.name?.inValid && (
                            <span className="text-danger mt-0">
                              {errors?.name?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="main-input d-flex my-2 justify-content-between align-items-center">
                        <div className="profile-labels add-list-all-labels text-left ">
                          <label htmlFor="" className="text-gr">
                            Surname
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper">
                          <CustomInput
                            name="surname"
                            placeholder="Last name"
                            onChange={handleForm}
                            value={formData?.surname}
                            wrapperClassName="mb-0"
                          />
                          {errors?.surname?.inValid && (
                            <span className="text-danger mt-0">
                              {errors?.surname?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="main-input d-flex my-2 justify-content-between align-items-center">
                        <div className="profile-labels add-list-all-labels text-left ">
                          <label htmlFor="" className="text-gr">
                            Email
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper">
                          <CustomInput
                            name="email"
                            placeholder="Enter email"
                            onChange={handleForm}
                            value={formData?.email}
                            wrapperClassName="mb-0"
                          />
                          {errors?.email?.inValid && (
                            <span className="text-danger mt-0">
                              {errors?.email?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="main-input d-flex my-2 justify-content-between align-items-center">
                        <div className="profile-labels add-list-all-labels text-left ">
                          <label htmlFor="" className="text-gr">
                            Mobile
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper">
                          <CustomInput
                            type="number"
                            name="phone"
                            blueborder={"true"}
                            placeholder="Enter mobile number"
                            onChange={handleForm}
                            value={formData?.phone}
                            wrapperClassName="mb-0"
                          />
                          {errors?.phone?.inValid && (
                            <span className="text-danger mt-0">
                              {errors?.phone?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="main-input d-flex my-2 justify-content-between align-items-start">
                        <div className="profile-labels add-list-all-labels text-left ">
                          <label htmlFor="" className="text-gr">
                            Start Date
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper">
                          <CustomInput
                            blueborder={"true"}
                            onClick={() => setDateCal((prev) => !prev)}
                            readOnly
                            start_icon={
                              <img
                                className="cursor-pointer"
                                onClick={() => setDateCal((prev) => !prev)}
                                src={CalendarIcon}
                                alt=""
                              />
                            }
                            type="text"
                            name="date"
                            value={
                              formData?.date
                                ? Moment(formData?.date?.toString()).format(
                                    "MMM Do YYYY"
                                  )
                                : ""
                            }
                            placeholder="mm/dd/yyyy"
                            className="text-center cursor-pointer text-sec"
                            wrapperClassName="mb-0"
                          />
                          {errors?.date?.inValid && (
                            <span className="text-danger mt-0">
                              {errors?.date?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="main-input mb-3 mt-1 d-flex my-1 justify-content-between align-items-start">
                        <div className="profile-labels add-list-all-labels text-left ">
                          <label htmlFor="" className="text-gr">
                            Number of guests
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper d-flex align-items-center">
                          <span
                            className="cursor-pointer user-select-none"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                guests:
                                  formData.guests - 1 > 0
                                    ? formData.guests - 1
                                    : 1,
                              });
                            }}
                          >
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM8.90909 12.7273C8.57154 12.7273 8.24782 12.8614 8.00914 13.1C7.77045 13.3387 7.63636 13.6625 7.63636 14C7.63636 14.3375 7.77045 14.6613 8.00914 14.9C8.24782 15.1386 8.57154 15.2727 8.90909 15.2727H19.0909C19.4285 15.2727 19.7522 15.1386 19.9909 14.9C20.2295 14.6613 20.3636 14.3375 20.3636 14C20.3636 13.6625 20.2295 13.3387 19.9909 13.1C19.7522 12.8614 19.4285 12.7273 19.0909 12.7273H8.90909Z"
                                fill={
                                  formData.guests - 1 > 0
                                    ? "#3F8BBF"
                                    : "#908E8E"
                                }
                              />
                            </svg>
                          </span>
                          <div className="guest_count_box">
                            {formData.guests > 9
                              ? formData.guests
                              : "0" + formData.guests}
                          </div>
                          <span
                            className="cursor-pointer user-select-none"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                guests: formData.guests + 1,
                              });
                            }}
                          >
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                            >
                              <path
                                d="M14 0C6.26875 0 0 6.26875 0 14C0 21.7312 6.26875 28 14 28C21.7312 28 28 21.7312 28 14C28 6.26875 21.7312 0 14 0ZM20 14.75C20 14.8875 19.8875 15 19.75 15H15V19.75C15 19.8875 14.8875 20 14.75 20H13.25C13.1125 20 13 19.8875 13 19.75V15H8.25C8.1125 15 8 14.8875 8 14.75V13.25C8 13.1125 8.1125 13 8.25 13H13V8.25C13 8.1125 13.1125 8 13.25 8H14.75C14.8875 8 15 8.1125 15 8.25V13H19.75C19.8875 13 20 13.1125 20 13.25V14.75Z"
                                fill="#3F8BBF"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="main-input d-flex my-1 justify-content-between align-items-start">
                        <div className="profile-labels add-list-all-labels text-left mt-1">
                          <label htmlFor="" className="text-gr">
                            Other Booking Notes
                          </label>
                        </div>
                        <div className="profile-inputs-wrapper">
                          <div className="boat-desc-wrappper mid-height mt-1 p-0">
                            <textarea
                              onChange={handleForm}
                              value={formData.description}
                              placeholder="Enter"
                              name="description"
                              className="m-0"
                            />
                            <div className="boat-desc-count d-flex justify-content-between align-items-center mt-2">
                              <span className="text-danger mt-0">
                                {errors?.description?.msg}
                              </span>
                              <span className="text-sec me-auo">
                                {formData?.description?.trim().length}/500
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 mt-4">
              <div className="mx-auto all-offers-slider-card">
                <Slide bottom>
                  <AllofferCard
                    data={{
                      onlyView: true,
                      tittle: selectedOffer?.title,
                      price: selectedOffer?.price,
                      viewMoreLink:
                        window.origin +
                        "/OfferDetails/" +
                        selectedOffer?.offer_id,
                      amenities: selectedOffer?.amenities,
                      extras: selectedOffer?.extras,
                      residenceText: selectedOffer?.brief_description,
                      users: selectedOffer?.num_of_people,
                      thumbnail:
                        api_domain + selectedOffer?.general_pictures[0],
                      img1: null,
                      img2: null,
                      period: selectedOffer?.duration +  (parseInt(selectedOffer?.duration) > 1 ? " days" : " day"),
                      location: selectedOffer?.location,
                      itinerary: selectedOffer?.itinerary,
                    }}
                  />
                </Slide>
              </div>
              {/* <div className="mx-auto all-offers-slider-card">
                                <div className="all-offers-top-img-grid">
                                    <div className="two-img-col">
                                        <img className="img_1" src={SliderImg_1} alt="scene 1" />
                                        <img className="img_2" src={null} alt="scene 2" />
                                    </div>
                                    <div className="one-img-col">
                                        <img src={null} alt="scene 3" />
                                    </div>
                                </div>
                                <h4 className="pt-2  m-0 text-center mx-auto">1st Offer</h4>
                                <div className="w-75 mx-auto">
                                    <hr className="my-1" />
                                </div>
                                <div className="w-100 text-center mx-auto  px-3 text-sec fw-bold">
                                    <h6 className="d-inline px-1">( 3 days)</h6> <svg className="mx-2" width="22" height="16" viewBox="0 0 22 16" fill="none">
                                        <path d="M10.949 10.5396C14.3802 10.5396 17.31 11.0836 17.31 13.2604C17.31 15.4362 14.399 16 10.949 16C7.51785 16 4.58809 15.456 4.58809 13.2802C4.58809 11.1034 7.49904 10.5396 10.949 10.5396ZM16.4351 9.22888C17.7468 9.20456 19.1571 9.38468 19.6782 9.51257C20.7823 9.72962 21.5084 10.1727 21.8093 10.8166C22.0636 11.3453 22.0636 11.9586 21.8093 12.4864C21.349 13.4851 19.8654 13.8058 19.2887 13.8886C19.1696 13.9066 19.0738 13.8031 19.0864 13.6833C19.3809 10.9157 17.0377 9.60353 16.4315 9.30183C16.4055 9.28832 16.4002 9.2676 16.4028 9.255C16.4046 9.24599 16.4154 9.23158 16.4351 9.22888ZM5.5656 9.22924C5.5853 9.23194 5.59515 9.24635 5.59694 9.25446C5.59962 9.26796 5.59425 9.28778 5.56918 9.30219C4.9621 9.60389 2.61883 10.9161 2.91342 13.6827C2.92595 13.8034 2.83104 13.9061 2.71195 13.889C2.13531 13.8061 0.651629 13.4855 0.191392 12.4867C-0.0637974 11.9581 -0.0637974 11.3457 0.191392 10.817C0.492248 10.1731 1.21752 9.72998 2.32156 9.51203C2.84358 9.38504 4.25294 9.20492 5.5656 9.22924ZM10.949 0C13.2851 0 15.1583 1.88227 15.1583 4.23285C15.1583 6.58254 13.2851 8.4666 10.949 8.4666C8.61292 8.4666 6.73974 6.58254 6.73974 4.23285C6.73974 1.88227 8.61292 0 10.949 0ZM16.6634 0.705896C18.9198 0.705896 20.6918 2.84123 20.0883 5.21974C19.6809 6.82102 18.2062 7.88463 16.5631 7.8414C16.3984 7.8369 16.2363 7.82159 16.0796 7.79457C15.9659 7.77476 15.9086 7.64597 15.973 7.55051C16.5998 6.62288 16.9571 5.50703 16.9571 4.30922C16.9571 3.05918 16.5667 1.8938 15.8889 0.938252C15.8674 0.908532 15.8513 0.862601 15.8728 0.828378C15.8907 0.800459 15.9238 0.78605 15.9551 0.778845C16.1835 0.732013 16.4181 0.705896 16.6634 0.705896ZM5.33593 0.705806C5.58127 0.705806 5.81586 0.731923 6.04509 0.778755C6.07553 0.78596 6.10956 0.80127 6.12746 0.828288C6.14806 0.862511 6.13284 0.908442 6.11135 0.938162C5.43353 1.89371 5.04313 3.05909 5.04313 4.30913C5.04313 5.50694 5.4004 6.62279 6.02718 7.55042C6.09165 7.64588 6.03434 7.77467 5.92063 7.79448C5.76304 7.8224 5.60186 7.83681 5.43711 7.84131C3.79404 7.88454 2.31932 6.82093 1.91191 5.21965C1.30751 2.84114 3.07951 0.705806 5.33593 0.705806Z" fill="#3F8BBF" />
                                    </svg>
                                    <span className="text-pr fw-bold px-2">6</span>
    
                                </div>
                                <div className="w-100 px-3">
                                    <h5 className="text-pr fw-bold">Residence</h5>
                                    <p className="fw-light mb-1 px-2">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nibh elementum libero maecenas metus in suscipit purus.
                                    </p>
                                </div>
                                <div className="w-100">
                                    <h5 className="text-pr px-3 fw-bold">Amenities</h5>
                                    <div className="row  m-0 mt-2 px-3">
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">SUP</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Yacht Slide</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Jetski</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Kayak</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Yacht Golf</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center  pb-0">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Yoga session</span>
                                            </div>
                                        </div>
                                    </div>
                                    <h5 className="text-pr mt-2 px-3 fw-bold">Extras</h5>
                                    <div className="row m-0 mt-2 px-3">
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">SUP</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Yacht Slide</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Jetski</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Kayak</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Yacht Golf</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 col-6 all_offers_extra_cols">
                                            <div className="fw-bold d-flex justify-content-start align-items-center">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z" fill="#92B9D5" />
                                                </svg>
                                                <span className="alloffer-slider-card-extras-names">Yoga session</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-100 py-2 text-center">
                                    <a href="/" target="_blank" rel="noopener noreferrer" className="text-decoration-underline fw-bold text-sec text-center mx-auto d-inline-block">View more</a>
                                </div>
                                <div className="w-100 row justify-content-center align-items-center m-0">
                                    <div className="col-md-6 mt-md-2"><span className="text-pr price-type-btn">200 €</span></div>
                                    <div className="col-md-6 mt-md-2"><button className="dark-btn book_now_btn">Book Now</button></div>
                                </div>
                            </div> */}
            </div>
            {/* submit */}
            <div className="col-12 mt-5 mb-4 text-center">
              <Slide bottom>
                <Button
                  onClick={submitOffer}
                  disabled={loader}
                  className="siginin_form_btn mt-md-3 mt-0  mb-3 text-white px-5"
                >
                  {loader ? "Submitting..." : "Reserve"}{" "}
                </Button>
              </Slide>
            </div>
          </div>
        </div>
        {/* Calendar Model pickup date*/}
        <CustomModel
          openPopup={pickupDateModal}
          setOpenPopup={setPickupCalendar}
        >
          <div className="date_menu cs_cal">
            <div className="intradaycalender">
              <Calendar
                onChange={(item) => {
                  setFormData({
                    ...formData,
                    pickup_date: item,
                  });
                  setPickupCalendar(false);
                  setErrors({
                    ...errors,
                    pickup_date: {
                      inValid: false,
                      msg: "",
                    },
                  });
                }}
                date={formData.pickup_date}
              />
            </div>
          </div>
        </CustomModel>
        {/* Calendar Model date*/}
        <CustomModel openPopup={dateModal} setOpenPopup={setDateCal}>
          <div className="date_menu cs_cal">
            <div className="intradaycalender">
              <Calendar
                onChange={(item) => {
                  setFormData({
                    ...formData,
                    date: item,
                  });
                  setDateCal(false);
                  setErrors({
                    ...errors,
                    date: {
                      inValid: false,
                      msg: "",
                    },
                  });
                }}
                date={formData.date}
              />
            </div>
          </div>
        </CustomModel>
        {/* sign In form model */}
        <CustomModel openPopup={loginModal} setOpenPopup={setLoginModal}>
          <SiginInPopup closeModel={setLoginModal} />
        </CustomModel>
      </div>
    );
  } else {
    return (
      <div className="confirmPage">
        {!user?.isAuth ? (
          <NotLoggedIn />
        ) : (
          <div className="container">
            <div className="row py-5 my-5">
              <Slide bottom>
                <Loader />
              </Slide>
            </div>
          </div>
        )}
      </div>
    );
  }
};

// REDUX CONFIGS
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(ConfirmBooking));
